import React, { useState } from "react";
import { Button, Empty, Modal, Card, Col, Row, Space, Avatar } from "antd";
import { PlusOutlined, BookOutlined, EditOutlined } from "@ant-design/icons";
import "./QuestionbanksList.scss"
import { useRouteMatch } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { currentUserSelector } from "../../Auth/Login/selector";
import { useTranslate } from "/src/lib/MrTranslate/MrTranslate";
import { actions as questionbankActions } from "../../Questionbanks/redux";

const QuestionBankCards = (props) => {
  console.log("QuestionBankCards =====>",props)
  const { questionbanks, history, renderForm } = props;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedQuestionbank, setSelectedQuestionbank] = useState({});
  const currentUser = useSelector(currentUserSelector());
  const dispatch = useDispatch();
  const currentUserPermission = currentUser.permission || {}
  const questionbankPermission = currentUserPermission.questionbank || {} 
  const originalUserRole = localStorage.getItem('originalUserRole');
  const originalUserRoleIsSuperAdmin = originalUserRole === "superadmin";
  const currentUserRole = currentUser.role;
  const isDistrictAdmin = currentUser.org.org_type === "district" && currentUserRole === "admin";
  let showCreateQbButton = (questionbankPermission.create || (originalUserRoleIsSuperAdmin && isDistrictAdmin)) ? true : false;
  let showEditQbButton = (questionbankPermission.update || (originalUserRoleIsSuperAdmin && isDistrictAdmin)) ? true : false;

  const match = useRouteMatch();
  const { path } = match;
  const mrIntl = useTranslate();

  const handleCardClick = (bank) => {
    if (currentUserRole !== "admin") {
      history.push(`${path}/${bank.id}/tests`);
      dispatch(questionbankActions.show({ id: bank.id }));
      setSelectedQuestionbank(bank);
    }
  }
  const showModal = () => {
    setIsModalVisible(true);
    setSelectedQuestionbank({});
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const handleEdit = (e, bank) => {
    e.stopPropagation();
    setIsModalVisible(true);
    setSelectedQuestionbank(bank);
  }

  return (
    <div className="questionbanks-list-container" >
      {showCreateQbButton ? <div className="questionbanks-header">
        <Button type="primary" icon={<PlusOutlined />} onClick={() => showModal()}>
          {mrIntl("QuestionbanksListForDistrict.create_bank")}
        </Button>
      </div> : null}
      <div>
        {questionbanks.length > 0 ? (
          <Row className="questionbanks-list-item">
            {questionbanks.map((bank) => (
              <Col className="questionbank-card-container" xs={24} sm={12} md={8} lg={6} key={bank.id}>
                <Card
                  onClick={() => handleCardClick(bank)}
                  className="text-center cursor-pointer clickable-card qb-card"
                  cover={
                    <div className="card-cover">
                      {showEditQbButton ?
                        <Button
                          type="link"
                          icon={<EditOutlined />}
                          onClick={(e) => handleEdit(e, bank)}
                        />
                        : null}
                    </div>
                  }
                >
                  <Space direction="vertical" align="center">
                    <Avatar
                      className={"default-logo-button"}
                    >
                      {bank.title?.charAt(0)}
                    </Avatar>
                    <h2 className="m-t-10">{bank?.title}</h2>
                    <span className="qb-meta-text">
                      {bank.settings?.dups_editable ? mrIntl("QuestionbanksListForDistrict.shared_library") : mrIntl("QuestionbanksListForDistrict.common_assessment_bank")}
                    </span>
                    {currentUserRole === "qb_author" ? <span className="qb-meta-text">
                      {bank.settings?.dups_editable ? "" : mrIntl("QuestionbanksListForDistrict.use_this_bank_to_create_common_assessment_across_schools")}
                    </span> : null}
                  </Space>
                </Card>
              </Col>
            ))}
          </Row>
        ) : (
          <Empty description={mrIntl("QuestionbanksListForDistrict.no_question_banks_available")} />
        )}
      </div>
      <Modal
        title={selectedQuestionbank?.id ? mrIntl("QuestionbanksListForDistrict.edit_question_bank") : mrIntl("QuestionbanksListForDistrict.create_question_bank")}
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width="50%"
        className="questionbanks-create-modal"
        key={isModalVisible}
      >
        {renderForm({
          name: "questionbanks",
          resource: selectedQuestionbank,
          config: {
            isModal: false,
            visible: true,
            actions: { showCancelBtn: true },
            handleCancelCallback: handleCancel,
            submitConfig: {
              successCallback: (data) => {
                setIsModalVisible(false);
              },
            },
          },
        })}
      </Modal>
    </div>
  )
}

const LibraryQuestionBankList = (props) => {
  console.log("LibraryQuestionBankListProps", props);
  const {
    history,
    renderForm,
    questionbanks = {}
  } = props;

  return (
    <div className="questionbanks-list-container">
      <QuestionBankCards questionbanks={questionbanks} history={history} renderForm={renderForm} />
    </div>
  );
};

export default LibraryQuestionBankList;
